import { useEffect, useRef } from 'react';

// Connects to the backend WebSocket and calls onMessage with parsed events.
// Reconnects automatically if the connection drops.
export function useWorkItemSync(onMessage) {
  const onMessageRef = useRef(onMessage);
  onMessageRef.current = onMessage;

  useEffect(() => {
    let ws = null;
    let retryTimeout = null;
    let destroyed = false;

    function connect() {
      const token = localStorage.getItem('token');
      if (!token || destroyed) return;

      const proto = window.location.protocol === 'https:' ? 'wss' : 'ws';
      ws = new WebSocket(`${proto}://${window.location.hostname}/api/ws?token=${token}`);

      ws.onmessage = e => {
        try { onMessageRef.current(JSON.parse(e.data)); } catch {}
      };

      ws.onclose = () => {
        if (!destroyed) retryTimeout = setTimeout(connect, 3000);
      };

      ws.onerror = () => ws.close();
    }

    connect();

    return () => {
      destroyed = true;
      clearTimeout(retryTimeout);
      if (ws) ws.close();
    };
  }, []);
}
